var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_5760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7151 10.8741L59.2634 50.0281C60.8438 52.7867 58.8019 56.1924 55.5483 56.1924H10.4517C7.19814 56.1924 5.15626 52.7867 6.73665 50.0281L29.2849 10.8741C30.9092 8.04848 35.0909 8.04848 36.7151 10.8741Z",
    stroke: "#DC0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 37.6299V27.3174",
    stroke: "#DC0000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 49.4893C34.4239 49.4893 35.5781 48.335 35.5781 46.9111C35.5781 45.4873 34.4239 44.333 33 44.333C31.5761 44.333 30.4219 45.4873 30.4219 46.9111C30.4219 48.335 31.5761 49.4893 33 49.4893Z",
    fill: "#DC0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_5760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(0 0.504883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.13162a986a2d6f1429f694daafa8cf3d.svg";
export { ForwardRef as ReactComponent };